import {PlayerColor} from '@colonist/game-states'

const PLAYER_COLOR_HEX_MAP: Record<PlayerColor, string> = {
    [PlayerColor.None]: '#00000000', // transparent
    [PlayerColor.Red]: '#ed1c24',
    [PlayerColor.Blue]: '#0072bc',
    [PlayerColor.Orange]: '#f77014',
    [PlayerColor.Green]: '#05bf00',
    [PlayerColor.Black]: '#58595b',
    [PlayerColor.Bronze]: '#b53723',
    [PlayerColor.Silver]: '#bcbec0',
    [PlayerColor.Gold]: '#f9d900',
    [PlayerColor.White]: '#e5eeea',
    [PlayerColor.Purple]: '#8d44c1',
    [PlayerColor.MysticBlue]: '#80dbff',
    [PlayerColor.Pink]: '#ff9eb7',
}

export function getPlayerColorHex(color: PlayerColor): string {
    return PLAYER_COLOR_HEX_MAP[color]
}

export type PlayerColorWithoutNone = Exclude<PlayerColor, PlayerColor.None>
